
import React from 'react';
import { useForm } from 'react-hook-form';
import { useSearchParams } from 'react-router-dom';
import { Navbar } from '../../../components/Navbar.jsx';
import { useVerificacionEmail } from '../../../features/auth/useVerificacionEmail.ts';

export function VerificarCorreoPage() {
  const [searchParams] = useSearchParams();
  const emailParam = searchParams.get('email') || '';
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm({
    defaultValues: {
      email: emailParam,
      codigo: '',
    },
  });
  const verificacion = useVerificacionEmail();

  // Si el email viene por la URL, autocompletar el campo
  React.useEffect(() => {
    if (emailParam) {
      setValue('email', emailParam);
    }
  }, [emailParam, setValue]);

  const onSubmit = (values) => {
    verificacion.mutate(values);
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-slate-100 dark:from-slate-900 dark:to-black">
      <Navbar />
      <main className="mx-auto flex max-w-6xl flex-col items-center px-4 py-12">
        <div className="w-full max-w-md rounded-3xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 p-6 sm:p-8 shadow-xl">
          <div className="text-center mb-8">
            <h1 className="text-2xl sm:text-3xl font-bold text-slate-900 dark:text-white">
              Verifica tu correo
            </h1>
            <p className="mt-3 text-sm sm:text-base text-slate-600 dark:text-slate-300">
              Ingresa el código que enviamos para activar tu cuenta.
            </p>
          </div>
          <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-6">
            <div>
              <label className="block text-sm font-semibold text-slate-700 dark:text-slate-200 mb-2">
                Correo electrónico
              </label>
              <input
                type="email"
                className="w-full rounded-xl border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-700 text-slate-900 dark:text-white px-4 py-3 text-base focus:border-sky-500 dark:focus:border-sky-400 focus:outline-none focus:ring-2 focus:ring-sky-500/20 dark:focus:ring-sky-400/20 placeholder:text-slate-400 dark:placeholder:text-slate-500 transition-colors"
                {...register('email', { required: 'Campo requerido' })}
              />
              {errors.email ? <p className="mt-1 text-sm text-rose-600 dark:text-rose-400">{errors.email.message}</p> : null}
            </div>
            <div>
              <label className="block text-sm font-semibold text-slate-700 dark:text-slate-200 mb-2">
                Código de verificación
              </label>
              <input
                type="text"
                className="w-full rounded-xl border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-700 text-slate-900 dark:text-white px-4 py-3 text-base focus:border-sky-500 dark:focus:border-sky-400 focus:outline-none focus:ring-2 focus:ring-sky-500/20 dark:focus:ring-sky-400/20 placeholder:text-slate-400 dark:placeholder:text-slate-500 transition-colors text-center tracking-widest"
                placeholder="000000"
                maxLength="6"
                {...register('codigo', { required: 'Campo requerido' })}
              />
              {errors.codigo ? <p className="mt-1 text-sm text-rose-600 dark:text-rose-400">{errors.codigo.message}</p> : null}
            </div>
            <button
              type="submit"
              className="mt-2 inline-flex items-center justify-center rounded-full bg-sky-600 dark:bg-sky-500 px-8 py-4 text-base font-semibold uppercase tracking-wide text-white shadow-lg hover:bg-sky-700 dark:hover:bg-sky-600 disabled:opacity-60 disabled:cursor-not-allowed transition-all duration-200 hover:shadow-xl hover:scale-[1.02] active:scale-[0.98]"
              disabled={verificacion.isPending}
            >
              {verificacion.isPending ? (
                <>
                  <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  Verificando...
                </>
              ) : (
                'Verificar cuenta'
              )}
            </button>
          </form>
        </div>
      </main>
    </div>
  );
}
